<template>
    <div class="site_description_div">
        <CardPlus class="site_description_card_plus"
                  v-for="(desc_info, index) in site_description"
                  :key="index"
                  :img_url="desc_info['img_url']"
                  :text="desc_info['text']"
        >
        </CardPlus>
    </div>
</template>

<script type="text/javascript">
import CardPlus from '../common_components/cards/card_plus.vue'
export default {
    data () {
        return {
            site_description: [
                {'img_url': '/static/img/introduceContainer1.gif',
                'text': '全面细致的课程体系'},
                {'img_url': '/static/img/introduceContainer2.gif',
                'text': '丰富你的实战经验'},
                {'img_url': '/static/img/introduceContainer3.gif',
                'text': '私人定制的成长套餐'},
                {'img_url': '/static/img/introduceContainer4.gif',
                'text': '记录你的成长经历'}]
            }
    },
    components: {
        CardPlus
    }
}

</script>

<style type="text/css" scoped>

.site_description_div {
    width: 1170px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    padding: 70px;
}

.site_description_card_plus {
    width: 25%;
}

</style>
